/* Aviso del inicio para el solicitante: solicitudes de capacitación a las que
 * la Coordinación les propuso otra fecha/horario (estado PROPUESTA) y esperan
 * que las acepte o responda.
 *
 * - No pinta nada si no tiene ninguna (o si falla la consulta).
 * - Solo consulta si el usuario entra a Solicitudes de Capacitación (permiso
 *   cacheado por sesión): así los operarios no suman una request por cada
 *   entrada al inicio. Si no es solicitante, el endpoint responde 403 y se
 *   ignora a propósito.
 * - Cada fila abre el detalle en Mis solicitudes, donde se acepta o responde;
 *   la tarjeta abre la lista.
 */
import { Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { fmtFechaHora } from "src/components/SolicitudCapacitacionCampos";
import SolicitudCapacitacionAPI, {
  cargarPermisoCapacitacion,
  SolicitudCapacitacion,
} from "src/services/solicitudCapacitacion";

const MAX_FILAS = 3;
const NARANJA = "#d35400";

const CapacitacionesPropuestasCard: React.FC = () => {
  const history = useHistory();
  const [items, setItems] = useState<SolicitudCapacitacion[]>([]);

  // Las rutas van en un <Switch>: el inicio se vuelve a montar al regresar
  // (por ejemplo, después de aceptar la propuesta), así que alcanza con useEffect.
  useEffect(() => {
    let vigente = true;
    cargarPermisoCapacitacion()
      .then((puede) => (puede === false ? null : SolicitudCapacitacionAPI.misSolicitudes()))
      .then((r) => {
        if (vigente && r) setItems((r.data.datos || []).filter((s) => s.estado === "PROPUESTA"));
      })
      .catch(() => vigente && setItems([]));
    return () => {
      vigente = false;
    };
  }, []);

  if (!items.length) return null;

  const ir = (id?: number) =>
    history.push(`/solicitudes-capacitacion?tab=mis${id ? `&id=${id}` : ""}`);

  return (
    <div className="container mt-1">
      <div
        onClick={() => ir()}
        style={{
          cursor: "pointer",
          background: "#fff",
          borderRadius: 10,
          borderLeft: `6px solid ${NARANJA}`,
          boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
          padding: "12px 14px",
          marginBottom: 10,
        }}
      >
        <Typography variant="caption" style={{ color: NARANJA, fontWeight: 700 }}>
          🎓 SOLICITUDES DE CAPACITACIÓN
        </Typography>
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
          {items.length === 1
            ? "Tenés 1 nueva fecha propuesta para confirmar"
            : `Tenés ${items.length} nuevas fechas propuestas para confirmar`}
        </Typography>

        {items.slice(0, MAX_FILAS).map((s) => (
          <div
            key={s.solicitud_id}
            onClick={(e) => {
              e.stopPropagation();
              ir(s.solicitud_id);
            }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 8,
              fontSize: 13,
              padding: "6px 0",
              borderTop: "1px solid #eee",
            }}
          >
            <span style={{ flex: 1 }}>
              N° {s.solicitud_id} · {s.ps_nombre}
            </span>
            <span style={{ whiteSpace: "nowrap", color: NARANJA, fontWeight: 600 }}>
              {fmtFechaHora(s.fecha_programada, s.hora_programada)}
            </span>
          </div>
        ))}

        <Typography variant="caption" style={{ color: NARANJA, fontWeight: 600 }}>
          {items.length > MAX_FILAS ? `Ver las ${items.length} →` : "Tocá para aceptar o responder →"}
        </Typography>
      </div>
    </div>
  );
};

export default CapacitacionesPropuestasCard;
